export const iconSizes = {
    small: '10px',
    medium: '14px',
    large: '24px',
    auto: 'auto',
};
